import { ThemeProvider } from "react-bootstrap";
import { RouterProvider } from "react-router-dom";
import ErrorBoundary from "./components/ErrorBoundary";
import { AppContextProvider } from "./contexts/AppContext";
import AppRoutes from "./routes/AppRoutes";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AppContextProvider>
        <ErrorBoundary>
          <ThemeProvider
            breakpoints={["xxxl", "xxl", "xl", "lg", "md", "sm", "xs", "xxs"]}
            minBreakpoint="xxs"
          >
            <RouterProvider router={AppRoutes} />
          </ThemeProvider>
        </ErrorBoundary>
      </AppContextProvider>
    </QueryClientProvider>
  );
}

export default App;
